import Button from '@/components/UI/Button'
import s from './ButtonActive.module.css'
import cn from 'classnames'
import { Link } from 'react-router-dom'
import { usersAPI } from '@/api'
import { AuthService } from '@/services/AuthService'
import { useAddAlert } from '@/hooks/useAddAlert'

const ButtonActive = (props) => {
  const addAlert = useAddAlert()

  const authorization = async () => {
    try {
      const response = await usersAPI.authorization(props.user.id)

      if(response?.data?.user?.id){
        AuthService.auth(response.data.user, response.data.token, response.data?.refresh_token)
        window.location.href = '/'
      } else {
        addAlert({title: 'Ошибка', text: 'При входе в ЛК произошла ошибка', type: 'error'})
      }
    } catch (error) {
      addAlert({
        title: 'Ошибка',
        text: error?.message || 'При входе в ЛК произошла ошибка',
        type: 'error',
      })
    }
  }

  const deleteUser = () => {
    usersAPI.disable({ id: props.user.id, data: props.user }).then((res) => {
      if (res.data.status === 'success') {
        window.location.reload()
      }
    })
  }

  const restoreUser = () => {
    usersAPI.restore({ id: props.user.id, data: props.user }).then((res) => {
      if (res.data.status === 'success') {
        window.location.reload()
      }
    })
  }

  return (
    <div className={s.wrapper}>
      {!props.settingCard.editMode && props.user.role === 'children' && (
        <Link to={'/journal'}>
          <Button styles="yellow" name="Перейти к успеваемости" />
        </Link>
      )}

      {props.settingCard.editMode && (
        <Button
          name={props.saves ? 'Сохранено' : 'Сохранить изменения'}
          styles={cn({ yellow: !props.saves }, { violet: props.saves })}
          className={s.secondaryButton}
          action={props.save}
        />
      )}

      {props.settingCard.editMode && props.settingCard.type !== 'personal' && (
        <>
          <Button name="Отмена" action={props.cancel} />
          <Button
            name="Сбросить пароль"
            action={() => props.setModal('RecoverPassword')}
          />
          {props.user.status != 0 && (
            <Button name="Авторизоваться" action={authorization} />
          )}
          {props.user.status != 0 && props.user.role == 'children' && (
            <Button name="Удалить" action={deleteUser} />
          )}
          {props.user.status != 0 && props.user.role != 'children' && (
            <Button name="Уволить" action={deleteUser} />
          )}
          {props.user.status == 0 && (
            <Button name="Восстановить" action={restoreUser} />
          )}
        </>
      )}
    </div>
  )
}

export default ButtonActive
